// @flow

import PropertyTypeValueField from './components/form/PropertyTypeValueField';
import AddUpdateEntityPropertyEditorForm from './components/form/AddUpdateEntityPropertyEditorForm';

export const components = {
    'form:AddEntityPropertyForm': AddUpdateEntityPropertyEditorForm,
    'formPaneField:PROPERTY_TYPE_VALUE': PropertyTypeValueField,    
}
